/**
 * Generates a CSS selector that includes a base selector and excludes a list of unwanted selectors
 * using the :not() pseudo-class.
 *
 * @param baseSelector The initial CSS selector string
 * @param unwantedSelectors An array of CSS selector strings that should be excluded
 * @returns A combined CSS selector string.
 *
 * @example
 * // How to use createExclusionSelector:
 * const base = 'button.action-btn';
 * const unwanted = ['.disabled', '[data-test-id="skip-button"]'];
 * const finalSelector = createExclusionSelector(base, unwanted);
 * console.log(finalSelector);
 * // Expected output: "button.action-btn:not(.disabled):not([data-test-id="skip-button"])"
 */
export function createExclusionSelector(baseSelector, unwantedSelectors) {
  const notClauses = unwantedSelectors.map(unwanted => `:not(${unwanted})`);
  return baseSelector + notClauses.join('');
}